import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { StepVector } from '../../../config/stepper-stage-map';
import { selectCreditTerms } from '../../../features/application/reducers/credit-terms.reducer';
import { APPLICATION_DENIED, APPLICATION_UNDER_REVIEW } from '../../../paths';
import { type CoastStepState } from '../coast-step-icon';

const offerOutcomeByRoute: Partial<Record<string, CoastStepState>> = {
  [APPLICATION_UNDER_REVIEW]: 'pending',
  [APPLICATION_DENIED]: 'rejected',
};

export const useStepperOverride = (): StepVector | undefined => {
  const { pathname } = useLocation();
  const { offers } = useSelector(selectCreditTerms);

  const outcome = offerOutcomeByRoute[pathname];

  if (!outcome) {
    return undefined;
  }

  return offers.length > 0 ? ['done', 'done', 'done', outcome] : ['done', 'done', outcome, 'notReached'];
};
